import React, { useState, useEffect, useMemo } from "react";
import DistributePopup from "./DistributePopup";
import { IoAdd } from "react-icons/io5";

const Distribute = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [tokenAmount, settokenAmount] = useState([]);
  const [data, setData] = useState([]);
  const [bool, setBool] = useState([]);

  const RastroContractAddress = "TNqDxpdP3Ey7FHpy9iMQqzjA3R8wgHtG9P";

  const tronWeb = useMemo(() => {
  
      return window.tronWeb;
    
  
  }, [window.tronWeb]); // Include window.tronWeb in the dependency array

  useEffect(() => {
    // Check TronWeb connection
    if (!tronWeb || !tronWeb.defaultAddress.base58) {
      console.error("TronLink is not connected or available.");
    }
  }, [tronWeb]);

  const connectWallet = async () => {
    try {
      if (!tronWeb || !tronWeb.defaultAddress.base58) {
        await window.tronLink.request({ method: "tron_requestAccounts" });
        console.log("Connected to TronLink:", tronWeb.defaultAddress.base58);
        // Update any component state or perform actions after connecting
      }
    } catch (error) {
      console.error("Failed to connect to TronLink:", error);
    }
  };

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const batchdistribute = async () => {
    console.log(addresses, tokenAmount);

    try {
      if (!tronWeb) {
        throw new Error("TronWeb is not initialized.");
      }

      const contract = await tronWeb.contract().at(RastroContractAddress);
      const trx = await contract.batchDistribute(addresses, tokenAmount).send();
      console.log("Transaction:", trx);
      const txId = trx.transaction.txID;
      console.log(
        `Transaction ID: https://shasta.tronscan.org/#/transaction/${txId}`
      );
    } catch (err) {
      console.error("Batch approval error:", err);
    }
  };

  return (
    <div>
      <div className=" min-w-screen font-main">
        <header className="w-full mt-10 text-gray-700   body-font">
          <div className="container flex flex-col items-start justify-between p-6 mx-auto md:flex-row">
            <a className="flex items-center mb-4 font-medium text-gray-900 title-font md:mb-0">
              <span className="ml-3 text-xl">Add Receipents to the list</span>
            </a>

            <div className="items-center ">
              <button
                onClick={openPopup}
                className="px-4 py-2 text-xs font-bold text-white uppercase transition-all duration-150 bg-[#2c749d] rounded shadow outline-none active:bg-teal-600 hover:shadow-md focus:outline-none ease"
              >
                <IoAdd size={20} />
              </button>
            </div>
          </div>
        </header>

        {/* Render the distributePopup component when isPopupOpen is true */}
        {isPopupOpen && (
          <DistributePopup
            addresses={addresses}
            setAddresses={setAddresses}
            tokenAmount={tokenAmount}
            settokenAmount={settokenAmount}
            bool={bool}
            setBool={setBool}
            batchdistribute={batchdistribute}
            setData={setData}
            data={data}
            isOpen={isPopupOpen}
            onClose={closePopup}
          />
        )}

        {/* Payment Details Table */}
        <div className="mx-auto max-w-xl px-4">
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    address
                  </th>
                  <th scope="col" className="px-6 py-3">
                    <div className="flex items-center">Amount</div>
                  </th>
                  <th scope="col" className="px-6 py-3">
                    <div className="flex items-center">Date/Time</div>
                  </th>
                </tr>
              </thead>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <tbody key={index}>
                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <th
                        scope="row"
                        className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                      >
                        {item.address}
                      </th>
                      <td className="px-6 py-4">{item.Amount}</td>
                      <td className="px-6 py-4">
                        {" "}
                        {new Date().toLocaleTimeString()}
                      </td>
                    </tr>
                  </tbody>
                ))
              ) : (
                <h2 className=" p-8 text-2xl">No Receipents added yet</h2>
              )}
            </table>
          </div>

          <div className="mt-10 flex justify-center space-x-4">
            <button
              onClick={connectWallet}
              className="px-4 py-2 bg-gray-50 text-gray-700 font-semibold rounded-md"
            >
              Add Receipents
            </button>
            <button
              onClick={batchdistribute}
              className="px-4 py-2 bg-[#2c749d] text-white rounded-md"
            >
              Batch Distribute
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Distribute;
